import {
  ChargePolicy,
  ProrationPolicy,
} from "@safetyculture/s12-apis-connect-web/s12/subscriptions/v1/subscriptions_pb";
import { ChargifyState } from "@safetyculture/s12-apis-connect-web/s12/tools/support/v1/support_payment_pb";

const GetProrationPolicy = (state: number): ProrationPolicy => {
  if (ChargifyState.TRIALING == state) {
    return ProrationPolicy.NONE;
  } else {
    return ProrationPolicy.PRORATED;
  }
};

const GetChargePolicy = (period: number): ChargePolicy => {
  if (period === 1) {
    return ChargePolicy.IMMEDIATE;
  }
  return ChargePolicy.DELAY;
};

export default { GetProrationPolicy, GetChargePolicy };
